import * as React from "react";
import { ModelClient, ModelPartnerClient } from "@dia-ui/util_interlink-api";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "app/context/AppContext";
import { generatePath, useNavigate } from "react-router";
import IconComponent from "../IconComponent";

const ClientDisplayComponentForm: React.FC<{ client: ModelClient }> = ({ client }) => {
  /**
   * navigate
   */
  const navigate = useNavigate();

  /**
   * context
   */
  const {
    services: {
      servicePartnerClient,
      serviceSystem
    },
    I18N,
    getRoutes
  } = useContext(AppContext);

  const [moduleType, setModuleType] = useState<string>("");

  useEffect(() => {
    (async () => {
      const m = await serviceSystem.getEnumInterlinkModulTypeById(client.type);
      setModuleType(m.description);
    })();
  }, [client.type, serviceSystem]);

  /**
   * partnerData: aktuell ausgewählter Partner
   */
  const [partnerData] = useState<ModelPartnerClient>(
    client.partnerClients && client.partnerClients.length > 0 ? client.partnerClients[0] : ({} as ModelPartnerClient)
  );

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * handleView
   * @param id
   * @param partnerId
   * @param type
   */
  const handleView = (id: string, partnerId: string, type: string) => {
    navigate(generatePath(ROUTE_CONFIG.CLIENT_PARTNER_VIEW_EDIT.path, {
      id: id,
      partnerId: partnerId,
      type: type
    }));
  };

  /**
   * handleTest
   * @param id
   * @param partnerHash
   * @param partnerId
   * @param type
   */
  const handleTest = (id: string, partnerHash: string, partnerId: string, type: string) => {
    navigate(generatePath(ROUTE_CONFIG.CLIENT_PARTNER_TEST.path, {
      id: id,
      partnerHash: partnerHash,
      partnerId: partnerId,
      type: type
    }));
  };

  /**
   * static variables
   */
  // @ts-ignore
  window.ClientOverviewComponent = {
    servicePartnerClient: servicePartnerClient,
    handleView: handleView,
    handleTest: handleTest,
    I18N: I18N,
    ROUTE_CONFIG_CLIENT_TEST: ROUTE_CONFIG.CLIENT_TEST
  };

  /**
   * handleTest
   * @param id
   * @param partnerId
   * @param type
   */
  const handleClientTest = (id: string, partnerId: string, type: string) => {
    navigate(generatePath(ROUTE_CONFIG.CLIENT_TEST.path, {
      id: id,
      partnerId: partnerId,
      type: type
    }));
  };

  return (
    <>
      <dia-grid-nested data-grid-nested-full-width>
        <dia-grid-row>
          <dia-grid-column>
            <dia-panel style={{ 'width':'405px' }}>
              <dia-panel-header>
                <IconComponent iconName={ ROUTE_CONFIG.CLIENT_OVERVIEW.icon } />
                <span style={{ marginLeft: "8px" }}>
                  { I18N.t("Allgemeine Daten") }
                </span>
              </dia-panel-header>
              <dia-panel-content>
                <dia-form>
                  <form>
                    <dia-form-area>
                      <dia-form-line>
                        <dia-form-control>
                          <input
                            id="client-detail-name"
                            type="text"
                            name="client-name"
                            placeholder=""
                            value={client ? client.id : ""}
                            readOnly
                          />
                          <label htmlFor="client-detail-name">{I18N.t("Client Name")}</label>
                        </dia-form-control>
                      </dia-form-line>
                      <dia-form-line>
                        <dia-form-control>
                          <label>{I18N.t("Status")}</label>
                          <dia-switch>
                            <input type="checkbox" id="status-switch" checked={ client.enabled } readOnly />
                            <label htmlFor="status-switch"></label>
                          </dia-switch>
                        </dia-form-control>
                      </dia-form-line>
                      <dia-form-line>
                        <dia-form-control>
                          <label>{ I18N.t("Modul") }:&nbsp;</label>
                          <strong>{ moduleType }</strong>
                        </dia-form-control>
                      </dia-form-line>
                      <dia-form-line>
                        <dia-form-control>
                          <input
                            id="client-detail-token"
                            has="password"
                            type="password"
                            name="client-token"
                            placeholder=""
                            value={client ? client.token : ""}
                            readOnly
                          />
                          <label htmlFor="client-detail-token">{I18N.t("Shared-Secret")}</label>
                        </dia-form-control>
                      </dia-form-line>
                    </dia-form-area>
                  </form>
                </dia-form>
              </dia-panel-content>
              <dia-panel-footer>
                <ul>
                  <li>
                    <button
                      data-secondary
                      onClick={ () => handleClientTest( client.id, client.partnerId, client.type ) }
                      title={ ROUTE_CONFIG.CLIENT_TEST.title }
                    >
                      <i data-icon-before={ ROUTE_CONFIG.CLIENT_TEST.icon }></i>
                      { ROUTE_CONFIG.CLIENT_TEST.title }
                    </button>
                  </li>
                </ul>
              </dia-panel-footer>
            </dia-panel>
          </dia-grid-column>
          <dia-grid-column>
            <dia-panel>
              <dia-panel-header>
                <IconComponent iconName={ ROUTE_CONFIG.PARTNER_VIEW_EDIT.icon } />
                <span style={{ marginLeft: "8px" }}>
                  { I18N.t("Partner-Verbindungen") }
                </span>
              </dia-panel-header>
              <dia-panel-content>
                <table data-partner-clients>
                  <thead>
                    <tr>
                      <th scope="col">{ I18N.t("Partner Name") }</th>
                      <th scope="col">{ I18N.t("Konfiguration") }</th>
                      <th scope="col">{ I18N.t("Aktion") }</th>
                    </tr>
                  </thead>
                  <tbody>
                  { client.partnerClients.map((partner) =>
                    <tr key={partner.partner_id}>
                      <td>{ partner ? partner.partner_id : "" }</td>
                      <td>
                        <dia-switch>
                          <input type="checkbox" id={ `partner-switch-${partner.partner_id}` } disabled={ partner.config && !partner.config.enabled } checked={ partner.active } readOnly />
                          <label htmlFor={ `partner-switch-${partner.partner_id}` }></label>
                        </dia-switch>
                      </td>
                      <td>
                        <button
                          data-small
                          data-primary-dark
                          data-icon-only
                          title={ I18N.t("Partner anzeigen") }
                          aria-label={ I18N.t("Partner anzeigen") }
                          onClick={ () => handleView(client.id, partner.id, partner.type) }
                        >
                          <i data-icon-before="eye"></i>
                        </button>
                        <button
                          data-small
                          data-secondary
                          data-icon-only
                          title={ I18N.t("API Test") }
                          aria-label={ I18N.t("API Test") }
                          onClick={ () => handleTest(client.id, partner.id /* partnerHash */, partner.partner_id, partner.type) }
                        >
                          <i data-icon-before="laptop-code"></i>
                        </button>
                      </td>
                    </tr>
                  ) }
                  </tbody>
                </table>
              </dia-panel-content>
            </dia-panel>
                {/* hier den JSON-Block-Konfiguration */}
            <dia-panel data-fullwidth>
              <dia-panel-header>
                <IconComponent iconName="laptop-code"/>
                <span>{I18N.t("JSON Konfiguration")}</span>
              </dia-panel-header>
              <dia-panel-content data-panel-no-padding>
                {partnerData?.config && (
                  <textarea
                    readOnly
                    has="code-mirror"
                    value={JSON.stringify(partnerData?.config ?? {}, null, 2)}
                  />
                )}
              </dia-panel-content>
            </dia-panel>
          </dia-grid-column>
        </dia-grid-row>
      </dia-grid-nested>
    </>
  );
};

export default ClientDisplayComponentForm;
